/**
 * A plan-node code as the UI shows it.
 *
 * BR-6 (`apps/api/src/domain/plan.ts`) derives the prefix from the node kind,
 * so a root node — stored as `kind: 'deliverable'` because BR-2 requires it —
 * is coded `D-1`. The Planning UI has no Deliverable concept: a top-level row
 * and a parent task are the same thing, so the `D-` series renders under the
 * same `T-` prefix as the rest of the plan.
 *
 * The two series cannot collide. `codeCounters` starts tasks at 100, so the
 * remapped roots occupy `T-1`…`T-99` and tasks run from `T-101` up.
 *
 * **Display only.** The stored code, `work_items.number` and TimeLog all keep
 * `D-1` — when cross-referencing a code against the database, the resource
 * planner or TLP, use the stored value, not what is on screen.
 */
export const displayPlanCode = (code: string | undefined): string =>
  code === undefined ? '—' : code.replace(/^D-/, 'T-');
